import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
html, body, #root {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  font-size: 100%;
  background: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.secondary};
}

#root {
  display: flex;
  flex-direction: column;
 }

body {
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
  font-weight: 400;
  line-height: 1.75;
}

.heroNav{
top: 50px; left: 50px;
position: fixed;

//background: green;
height: 100vh;
display: flex;
flex-direction: column;

justify-content: center;

align-content: center;

align-items: center;

}

.heroLinkContainer{
  height: 100%;
  //background: blue;
  display: flex;
  flex-direction: column;

  justify-content: center;

  align-content: center;

  align-items: center;

  gap: 100px;

}



.heroLinkContainer{
  display: flex;
  flex-direction: column;
  align-items: start;
  list-style-type: none;
  text-decoration: none;


  .heroLinks{
  //  padding: 6px 0;

  
    a {
      position: relative;
      display: block;
      padding: 0px 0;
      color:  ${({ theme }) => theme.secondary};
     // text-decoration: none;
      text-transform: uppercase;
      transition: 0.5s;

      &::after {
        position: absolute;
        content: "";
        top: 100%;
        left: 0;
        width: 100%;
        height: 8px;
        background: ${({ theme }) => theme.third};
        transform: scaleX(0);
        transform-origin: right;
        transition: transform 0.5s;
      }

      &:hover {
        color: #95a5a6;
      }

      &:hover::after {
        transform: scaleX(1);
        transform-origin: left;
      }
      &:active {
 

 color: blue;

      }

    }
  }
}

.portfolio-container{
//outline-style: solid;
//outline-color: red;

}
.portfolio-column{
width: 100%;
//outline-style: solid;
//outline-color: yellow;
}

.portfolio-item{
  max-width: 100%;
  
//outline-style: solid;
//outline-color: blue;
display: grid;
grid-template-columns: 40% repeat(2, 30%);
grid-template-rows: 20% 80%;
grid-column-gap: 0px;
grid-row-gap: 0px; 

.portfolio-item-git{
  a {
    color: ${({ theme }) => theme.secondary};  
  }
}

}:visited{
  color: ${({ theme }) => theme.secondary};
}

.portfolio-item-title{ 
  
} 

.portfolio-item-URL{
 // color: ${({ theme }) => theme.secondary};
  grid-area: 1 / 2 / 2 / 3;  
  //outline-style: solid;
  //outline-color: green;


}:visited{
  //color: ${({ theme }) => theme.secondary};
}:hover{
  //color: blue;

}

.portfolio-item-URL a:hover{
  color: #15cdfc; 
}

.portfolio-item-git a:hover{
  color: #15cdfc; 
}


.portfolio-item-git{
  grid-area: 1 / 3 / 2 / 4;
 // outline-style: solid;
 // outline-color: yellow;
}

.portfolio-item-image{
  grid-area: 1 / 1 / 3 / 2;
  //height: 80%;

}

.portfolio-item-text{
  grid-area: 2 / 2 / 3 / 4; 

}

.form-input{
  font-family: 'Readex Pro', sans-serif;
  background: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.secondary};
  border-style: none;
  //filter: invert(90%);
}

form{
  display: flex;
  flex-direction: column;
  width: 500px;
 min-width: 500px;
  font-family: 'Readex Pro', sans-serif;
}

input{
  width: 100%;
  height: 30px;
  font-size: 100%;
  background: ${({ theme }) => theme.primary};
   color: ${({ theme }) => theme.secondary};
  font-family: 'Readex Pro', sans-serif;
  border-color:  ${({ theme }) => theme.secondary};
  border-radius: 5px;
}

.contact-btn{
  width: 101%;
  height: 60px;
  background: ${({ theme }) => theme.third};
   color: white;
  font-family: 'Readex Pro', sans-serif;
  border-color:  ${({ theme }) => theme.secondary};
  border-radius: 5px;
}:hover{
border-color: ${({ theme }) => theme.third}; 
}

textarea{
 width: 110%;
 max-width: 100%;
 background: ${({ theme }) => theme.primary};
 color: ${({ theme }) => theme.secondary};
font-family: 'Readex Pro', sans-serif;
border-color:  ${({ theme }) => theme.secondary};
border-radius: 5px;
}

.icon-wrapper{
  display: flex; 
  flex-wrap: wrap; 
  flex-direction: row;
justify-content: center;
}

.social-icons{
  color: ${({ theme }) => theme.secondary};
  border-radius: 5px;
}

.social-icons:hover{
  
  color: #15cdfc;
  //transition: 0.50s;
//outline-style: dashed;
//outline-color: ${({ theme }) => theme.secondary};
//outline-width: 3px;
}

/* header{
  width: 100%;
  display: flex;
}

.nav-me{
  width: 100%;
  height: 50px;
  background: ${({ theme }) => theme.navColor};
  color: white;
  position: fixed;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
  
  .ul-me {
    display: flex;
    list-style-type: none;
  }
  .li-me {
    margin: 0 15px;
    justify-content: space-between;
    font-size: 1em;
    list-style-type: none;
  }
  a {
    font-size: 1em;
    text-decoration: none;
    .active {
      color: tomato;
    }
  }
  a.active {
    color: #15cdfc;
  }



a {
  color:white;

  transition: all 0.9s;
  color: white;
  font-size: 1em;
}
a:hover {
  opacity: 1;
}
.fabars {
  display: none;
  color: white;
  font-size: 2rem;
} */

.social-container{
  //width: 30%;

  display: flex;
  flex-wrap: wrap; 
  justify-content: center;
  text-align: center;
  }

.column-wrapper{
  display: flex;
  flex: 0 1 24%;

}
.card-container{
  width: 100%;
}



.card-row{

width: 100%;
display: flex;
flex-wrap: wrap;


}

.card{
}

 a .card {
   display: flex;
   flex-direction: column;
   align-content: center;
  align-items: center;
  border-radius: 5px;
border-style: ridge;
border-width: 1px;
border-color:  ${({ theme }) => theme.secondary};
text-decoration: none!important;
  width: 270px;
  height: 550px;

  background-color: #${({ theme }) => theme.article};
color: ${({ theme }) => theme.secondary};

  gap: 10%;
  margin: 20px;
  box-shadow: 0px 0px 5px 1px  ${({ theme }) => theme.bannerShadowBox};
  }

a: hover .card {
  border-color:  ${({ theme }) => theme.third};
}

a: link{
  text-decoration: none!important; 
}

a: visited{
 // color: white;
}

.card a:link{
 // color: gold;
 // text-decoration: none!important;
}

.card: a:visited{
 // text-decoration: none!important;
  //color: gold;
}

.card a:active{
  //text-decoration: none!important;
  //color: gold;
}

.card a:hover{
 // text-decoration: none!important;
 // color: gold;
}

.card-content{
  text-align: center;
}

.card-image{
width: 100%;
filter: invert(0.08);
}

.card-image:hover{
transform: scale(1.1);
}


.heroFull{
  display:flex;
  flex-direction: column;
  min-height: 70vh;
  height: 100%;

  -webkit-justify-content: center;
-ms-flex-pack: center;
justify-content: center;
-webkit-align-content: center;
-ms-flex-line-pack: center;
align-content: center;
-webkit-align-items: center;
-ms-flex-align: center;
align-items: center;
background: none;
box-shadow: none;
}

.heroMid{

  //max-height: 50vh;
  outline-style: solid;
  outline-color: blue;

}

.hidden{
  display:none;
}

main {
margin-top: 50px;
flex: 1 0 auto;
width: 100%;
display: -ms-flexbox;
display: -webkit-flex;
display: flex;
-webkit-flex-direction: column;
-ms-flex-direction: column;
flex-direction: column;
-webkit-flex-wrap: wrap;
-ms-flex-wrap: wrap;
flex-wrap: wrap;
-webkit-justify-content: center;
-ms-flex-pack: center;
justify-content: flex-start;
-webkit-align-content: center;
-ms-flex-line-pack: center;
align-content: center;
-webkit-align-items: center;
-ms-flex-align: center;
align-items: center;
}

footer {
background:  ${({ theme }) => theme.navColor};
color: white;
min-height: 50px;
height: 50px;
display: flex;
width: 100%;
margin-top: auto;
-webkit-justify-content: center;
-ms-flex-pack: center;
justify-content: center;
-webkit-align-content: center;
-ms-flex-line-pack: center;
align-content: center;
-webkit-align-items: center;
-ms-flex-align: center;
align-items: center; 

}

.imgcon{
  //display: flex;
  margin: 2%;  

  justify-content: space-beween;
}

.imgico{
  height: 90px;
 filter: ${({ theme }) => theme.filterColor};
}

.imgcon:focus::after{
  position: absolute;
  width: 90px;
  transform: translate(-96%,-120%);

 
  content: attr(title);
  background-color: ${({ theme }) => theme.primary};
  border-style: solid;
  border-radius: 10px;
  border-color: ${({ theme }) => theme.secondary};
  color:${({ theme }) => theme.secondary};
  font-size: 90%;
  text-align: center;
}

.imgico:hover{
  //background-color: ${({ theme }) => theme.skillShadowBoxcolor};  
 // transform: scale(1.25);

}


.imgico:focus {
  //background-color: ${({ theme }) => theme.skillShadowBoxcolor};
  //transform: scale(1.4);

}

    .btn-hidden{
    border: transparent;
    background-color: transparent;
    color: transparent;
    padding: 10px;
    position: absolute;
    top: 0;
    right: 5px;
  }

p {margin-bottom: 1rem;}

h1, h2, h3, h4, h5 {
  margin: 3rem 0 1.38rem;
  font-family: 'Readex Pro', sans-serif;
  font-weight: 400;
  line-height: 1.3;
}

h1 {
  margin-top: 0;
  font-size: 3.052rem;
}

h2 {font-size: 2.441rem;}

h3 {font-size: 1.953rem;}

h4 {font-size: 1.563rem;}

h5 {font-size: 1.25rem;}

small, .text_small {font-size: 0.8rem;}

  section {

    max-width: 1200px;
}

  article{
  
margin: 5%;
   padding: 5%;

    border-radius: 5px;
    background: ${({ theme }) => theme.article};
    box-shadow: 0px 0px 25px 1px ${({ theme }) => theme.shadowBoxColor};

    -webkit-order: 0;
    -ms-flex-order: 0;
    order: 0;
    -webkit-flex: 0 1 auto;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;

    
  }

  .blog-hero{
    margin: 5%;
    padding: 5%;
    background: ${({ theme }) => theme.article};
    box-shadow: 0px 0px 25px 1px ${({ theme }) => theme.shadowBoxColor};
    border-radius: 5px;
  }

  .blog-section{
    width: min(1200px, 100%);
    margin: 0 auto;
    padding-bottom: 3rem;
  }

  .blog-post-section{
    padding-top: 4rem;
  }

  .blog-grid{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 24px;
    padding: 0 5% 5%;
  }

  .blog-card{
    background: ${({ theme }) => theme.article};
    box-shadow: 0px 0px 25px 1px ${({ theme }) => theme.shadowBoxColor};
    border-radius: 5px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
  }

  .blog-grid .blog-card:hover{
    transform: translateY(-6px);
    box-shadow: 0px 10px 30px 4px ${({ theme }) => theme.shadowBoxColor};
  }

  .blog-grid .blog-card:hover .blog-image{
    transform: scale(1.05);
  }

  .blog-card-content{
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    min-height: 0;
  }

  .blog-title a{
    color: ${({ theme }) => theme.secondary};
    text-decoration: none;
  }

  .blog-title a:hover{
    color: ${({ theme }) => theme.third};
  }

  .blog-title{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .blog-subtitle{
    margin-top: 0.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .blog-meta{
    color: ${({ theme }) => theme.secondary};
    opacity: 0.8;
    font-size: 0.9rem;
  }

  .blog-categories{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .blog-category-chip{
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.8rem;
    letter-spacing: 0.02em;
    background: rgba(21, 205, 252, 0.12);
    color: ${({ theme }) => theme.third};
    border: 1px solid rgba(21, 205, 252, 0.25);
    text-decoration: none;
  }

  .blog-category-chip:hover{
    border-color: rgba(21, 205, 252, 0.6);
  }

  .blog-category-chip.active{
    background: rgba(21, 205, 252, 0.25);
    border-color: rgba(21, 205, 252, 0.8);
  }

  .blog-location{
    margin-top: 0.4rem;
    font-size: 0.95rem;
  }

  .blog-location a{
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.third};
    text-decoration: none;
  }

  .blog-location a:hover{
    text-decoration: underline;
  }

  .blog-location-icon{
    display: inline-flex;
    width: 16px;
    height: 16px;
    opacity: 0.8;
  }

  .blog-location-icon svg{
    width: 100%;
    height: 100%;
    fill: currentColor;
  }

  .blog-image{
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
    aspect-ratio: auto;
    transition: transform 0.35s ease;
  }

  .blog-grid .blog-image{
    height: 200px;
    aspect-ratio: 16 / 9;
  }

  .blog-post .blog-image{
    height: auto;
    aspect-ratio: auto;
    transform: none !important;
  }

  .blog-image-link{
    display: block;
  }

  .blog-read-more{
    display: inline-block;
    margin-top: auto;
    color: ${({ theme }) => theme.third};
  }

  .blog-admin-actions{
    margin-top: 0.75rem;
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .blog-admin-actions button{
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.third};
    cursor: pointer;
    padding: 0;
  }

  .blog-post{
    padding: 5%;
    margin-bottom: 4rem;
    height: auto;
  }

  .blog-hero-image{
    margin: 1rem 0 2rem;
    border-radius: 5px;
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .blog-content p{
    margin-bottom: 1rem;
  }

  .blog-rich-image{
    margin: 1.5rem 0;
  }

  .blog-rich-image.full-width{
    width: 100%;
  }

  .blog-rich-image figcaption{
    margin-top: 0.5rem;
    font-size: 0.9rem;
    opacity: 0.8;
  }

  .blog-code-block{
    background: ${({ theme }) => theme.codeBlockBg};
    border: 1px solid ${({ theme }) => theme.codeBlockBorder};
    box-shadow: ${({ theme }) => theme.codeBlockShadow};
    padding: 16px;
    border-radius: 8px;
    overflow-x: auto;
    font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
    font-size: 0.95rem;
    line-height: 1.6;
    color: ${({ theme }) => theme.codeText};
  }

  .blog-code-block code{
    color: ${({ theme }) => theme.codeText};
    white-space: pre;
  }

  .blog-code-block,
  .blog-code-block[class*="language-"]{
    background: ${({ theme }) => theme.codeBlockBg} !important;
    color: ${({ theme }) => theme.codeText} !important;
  }

  .blog-code-block code,
  .blog-code-block code[class*="language-"]{
    color: ${({ theme }) => theme.codeText} !important;
    text-shadow: none !important;
    background: transparent !important;
  }

  .blog-code-block .token.comment{ color: ${({ theme }) => theme.codeTokenComment} !important; }
  .blog-code-block .token.keyword{ color: ${({ theme }) => theme.codeTokenKeyword} !important; }
  .blog-code-block .token.string{ color: ${({ theme }) => theme.codeTokenString} !important; }
  .blog-code-block .token.function{ color: ${({ theme }) => theme.codeTokenFunction} !important; }
  .blog-code-block .token.number{ color: ${({ theme }) => theme.codeTokenNumber} !important; }
  .blog-code-block .token.boolean{ color: ${({ theme }) => theme.codeTokenNumber} !important; }
  .blog-code-block .token.operator{ color: ${({ theme }) => theme.codeTokenOperator} !important; }
  .blog-code-block .token.punctuation{ color: ${({ theme }) => theme.codeTokenPunctuation} !important; }

  .code-snippet-block{
    background: ${({ theme }) => theme.codeBlockBg};
    border: 1px solid ${({ theme }) => theme.codeBlockBorder};
    box-shadow: ${({ theme }) => theme.codeBlockShadow};
    padding: 16px;
    border-radius: 8px;
    color: ${({ theme }) => theme.codeText};
    font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
    font-size: 0.95rem;
    line-height: 1.6;
  }

  .code-snippet-meta{
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    opacity: 0.7;
    margin-bottom: 8px;
  }

  .blog-author{
    display: flex;
    align-items: center;
    gap: 14px;
    margin: 1rem 0 1.5rem;
  }

  .blog-author-image{
    width: 56px;
    height: 56px;
    border-radius: 50%;
    object-fit: cover;
  }

  .blog-author-name{
    margin: 0;
    font-weight: 600;
  }

  .blog-author-location{
    margin: 0.15rem 0 0;
    font-size: 0.9rem;
    opacity: 0.75;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .blog-author-location-icon{
    display: inline-flex;
    width: 16px;
    height: 16px;
    opacity: 0.8;
  }

  .blog-author-location-icon svg{
    width: 100%;
    height: 100%;
    fill: currentColor;
  }

  .blog-author-bio{
    margin: 0.2rem 0 0;
    opacity: 0.85;
    font-size: 0.95rem;
  }

  .blog-author-card{
    margin-top: 2.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid rgba(255,255,255,0.08);
  }

  .blog-author-card-inner{
    display: flex;
    align-items: center;
    gap: 16px;
    background: ${({ theme }) => theme.article};
    box-shadow: 0px 0px 25px 1px ${({ theme }) => theme.shadowBoxColor};
    border-radius: 8px;
    padding: 16px;
  }

  .blog-author-socials{
    margin-top: 0.6rem;
  }

  .blog-author-socials .social-container{
    justify-content: flex-start;
    gap: 10px;
  }

  .blog-author-socials .imgcon{
    margin: 0;
  }

  .admin-card{
    padding: 5%;
    width: 100%;
    max-width: 1400px;
  }

  .admin-categories{
    border: none;
    padding: 0;
    margin: 1rem 0 0.5rem;
  }

  .admin-category-list{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 0.5rem;
    align-items: flex-start;
  }

  .admin-category{
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 10px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.03);
    cursor: pointer;
    width: 220px !important;
    justify-content: flex-start;
    min-height: 40px;
    flex: 0 0 auto;
  }

  .admin-category input[type="checkbox"]{
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    margin: 0;
    flex: 0 0 16px;
  }

  .admin-category span{
    color: ${({ theme }) => theme.secondary};
    text-align: left;
    white-space: normal;
    line-height: 1.2;
    overflow: visible;
  }

  .admin-category input{
    margin: 0;
  }

  .admin-category:hover{
    border-color: rgba(21,205,252,0.45);
  }

  .admin-category input:checked + span{
    color: ${({ theme }) => theme.third};
  }

  .admin-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .admin-form{
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 1200px;
  }

  .admin-card form{
    width: 100%;
    min-width: 0;
  }

  .admin-card label{
    width: 100%;
  }

  .admin-form label.admin-checkbox{
    width: auto !important;
    align-self: flex-start;
    display: inline-flex !important;
    flex-direction: row !important;
    justify-content: flex-start !important;
    gap: 12px !important;
  }

  .admin-form label.admin-checkbox span{
    margin: 0;
  }

  .admin-form label{
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .admin-checkbox{
    flex-direction: row !important;
    align-items: center;
    gap: 10px !important;
    justify-content: flex-start;
    width: fit-content;
    align-self: flex-start;
  }

  .admin-checkbox input{
    margin: 0;
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    flex: 0 0 16px;
  }

  .admin-message{
    margin-top: 0.5rem;
  }

  .admin-card .tox-tinymce{
    border-radius: 6px;
    border-color: ${({ theme }) => theme.secondary};
    min-height: 700px;
    width: 100% !important;
  }

  .admin-card .tox{
    max-width: none;
  }

  @media only screen and (max-width: 900px) {
    .admin-card{
      width: 92%;
      margin: 0 auto;
    }

    .admin-header{
      flex-direction: column;
      align-items: stretch;
    }

    .admin-form input,
    .admin-form textarea{
      width: 100%;
    }

    .contact-btn{
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    .admin-card{
      padding: 6%;
    }

    .admin-form{
      gap: 12px;
    }

    .admin-card .tox-toolbar__group{
      flex-wrap: wrap;
    }
  }

  .admin-rich-image-preview{
    margin-top: 1rem;
  }

  .admin-rich-image-grid{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
  }

  .admin-rich-image-item{
    margin: 0;
    background: ${({ theme }) => theme.article};
    padding: 10px;
    border-radius: 6px;
  }

  .admin-rich-image-item img{
    width: 100%;
    height: auto;
    border-radius: 4px;
  }

  .admin-rich-image-item figcaption{
    margin-top: 6px;
    font-size: 0.85rem;
    opacity: 0.8;
  }

  .admin-rich-image-missing{
    padding: 12px;
    border: 1px dashed ${({ theme }) => theme.third};
    border-radius: 6px;
    font-size: 0.85rem;
  }

  .ql-editor{
    min-height: 220px;
    font-family: 'Readex Pro', sans-serif;
    color: ${({ theme }) => theme.secondary};
  }

  .ql-editor h1{ font-size: 2.5rem; margin: 1rem 0; }
  .ql-editor h2{ font-size: 2rem; margin: 1rem 0; }
  .ql-editor h3{ font-size: 1.6rem; margin: 0.75rem 0; }
  .ql-editor h4{ font-size: 1.3rem; margin: 0.75rem 0; }
  .ql-editor h5{ font-size: 1.1rem; margin: 0.5rem 0; }
  .ql-editor h6{ font-size: 1rem; margin: 0.5rem 0; }

  .ql-editor pre{
    background: rgba(0,0,0,0.35);
    padding: 16px;
    border-radius: 6px;
    overflow-x: auto;
    color: ${({ theme }) => theme.secondary};
  }

  article.hero{
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: center;
  }

 article .noBoxShadow{
      background: white;
  }

  .some-page-wrapper {
    margin: 0 auto;
  }
  
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }
  
  .column {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    height: 100%;
    border: solid;
    border-width 0;
    padding: 1%;
  }

  .column-skills {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    height: 100%;
    border: solid;
    border-width 0;
    padding: 2%;
  }

  .column-skills:hover{
    background-color: ${({ theme }) => theme.skillShadowBoxcolor};  
    transform: scale(1.02);

  }
  
  
  .column-skills:focus {
    background-color: ${({ theme }) => theme.skillShadowBoxcolor};
    transform: scale(1.03);
  
  }

  @media screen and (max-width: 1300px) {

    .heroLinkContainer{
display: none;
      }


    }
  

  
  @media screen and (min-width: 1000px) {
    .column {
      flex: 1
    }

    .column-skills {
      flex: 1
    }
  
    .double-column {
      flex: 2
    }
  }

  @media only screen and (max-width: 800px) {

    form{
      width: 100%;
      //background: ${({ theme }) => theme.article};
    }

    .form-input{
      background: ${({ theme }) => theme.article};
     // height: 100%;
    }
    
    .heroFull{
      min-height: 100vh;
      height: 100%;
    }

    form{
      display: flex;
      flex-direction: column;

     // width: 100px;
     min-width: 100%;
      font-family: 'Readex Pro', sans-serif;
    }

card-container{
display: flex;

}




    .card-row{
      width: 100%;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
    }

  
  .portfolio-item{
    display: flex;
    flex-direction: column;
    height: 100%;
  }

    .nav-me{
      background: steelblue;
      flex-direction: column;
      height: auto%;
    }

    .li-me{
      height: 50px;
      width: 100%;
      min-height: 50px;
      background: steelblue;
    }


    .ul-me {
      height: 100%;
      flex-direction: column;
      background: steelblue;
    }


    .name{
        font-family: 'Hurricane', cursive;
        font-size: 65px;
        line-height: 30px;  
    }
    .centerNameContent{

      margin: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-right: -50%;
      transform: translate(-50%, -50%);
      background: none;
      box-shadow: none;
  
    }
    

    section {
      width: 100%;
      margin: 0 auto;
  }

    article{
      width: 90%;
      margin: 0 auto;
      padding: none;
      overflow:hidden;
      background: none;
      box-shadow: none;
      font-size: 14px;
    }

    .imgcon{
      //display: grid-auto;
      margin: 3%;
      
    }
    
    .imgcon:focus::after{
      position: absolute;
      width: 59px;
      transform: translate(-96%,-100%);
      content: attr(title);
      background-color: rgba(0,0,0,0.6);
      border-radius: 10px;
      color:white;
      font-size: 80%;
    }

    .imgico{
      height: 59px;   
     //filter: invert(0.99);
    }


    h2{
      font-size:19px;
    }

    h1{
      font-size: 21px;
    }


* {
  -moz-box-sizing: border-box;
  -webkit-kit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
}


`;

export const light = {
  primary: "#F2FDFF",
  secondary: "#101935",
  third: "#15cdfc",
  article: "#F2FDFF",
  shadowBoxColor: "none",
  navColor: "#030E17",
  skillShadowBoxcolor: "rgba(0,0,0,0.1)",
  filterColor: "invert(0%)",
  bannerShadowBox: "rgba(0,0,0,0.6)",
  codeBlockBg: "#F5F7FA",
  codeBlockBorder: "rgba(15, 23, 42, 0.12)",
  codeBlockShadow: "0 8px 16px rgba(15, 23, 42, 0.06)",
  codeText: "#0f172a",
  codeTokenComment: "#6b7280",
  codeTokenKeyword: "#2563eb",
  codeTokenString: "#0f766e",
  codeTokenFunction: "#9a3412",
  codeTokenNumber: "#7c3aed",
  codeTokenOperator: "#334155",
  codeTokenPunctuation: "#334155",
};
// 011627 like it
export const dark = {
  //primary: "#11191f",
  //secondary: "#bbc6ce",
  //article: "#18232c",
  //primary: "#00111c",
  //secondary: "#bbc6ce",
  //article: "#011627",
  primary: "#08090C",
  secondary: "#bbc6ce",
  third: "#15cdfc",
  article: "#101218",
  shadowBoxColor: "rgba(0,0,0,0.4)",
  navColor: "#030E17",
  skillShadowBoxcolor: "rgba(0,0,0,0.4)",
  filterColor: "invert(90%)",
  bannerShadowBox: "rgba(255,255,255,0.21)",
  codeBlockBg: "#1b1f2a",
  codeBlockBorder: "rgba(255, 255, 255, 0.08)",
  codeBlockShadow: "none",
  codeText: "#e2e8f0",
  codeTokenComment: "#94a3b8",
  codeTokenKeyword: "#7dd3fc",
  codeTokenString: "#5eead4",
  codeTokenFunction: "#fdba74",
  codeTokenNumber: "#c4b5fd",
  codeTokenOperator: "#cbd5f5",
  codeTokenPunctuation: "#cbd5f5",
};

export const Navigation = styled.header`
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  position: fixed;
  align-items: center;
  height: 50px;
  background: ${({ theme }) => theme.navColor};

  .logo a {
    padding-top: 33px;
    display: flex;
    flex-direction: column;
    clear: both;
    padding-bottom: 30px;
    text-decoration: none;
  }
  .gray {
    color: #ccc;
  }
  a {
    color: white;

    transition: all 0.9s;
    color: white;
    font-size: 1em;
  }
  a:hover {
    opacity: 1;
  }
  .fabars {
    display: none;
    color: white;
    font-size: 2rem;
  }
  nav {
    ul {
      display: flex;
      justify-content: space-between;
      list-style-type: none;
    }
    li {
      margin: 0 15px;
      justify-content: space-between;
      font-size: 1em;
      list-style-type: none;
    }
    a {
      font-size: 1em;
      text-decoration: none;
      .active {
        color: tomato;
      }
    }
    a.active {
      color: #15cdfc;
    }
  }

  @media only screen and (max-width: 800px) {
    padding: 0px;
    .logo {
      padding-left: 15px;
      padding-top: 0px !important;
    }

  }
  @media only screen and (max-width: 600px) {
    height: auto;
    min-height: 50px;
    display: block;

    .logo {
      width: 100%;
      display: block;
      padding-top: 20px;
      margin: 0px;
      margin-left: -5px;
      a {
        padding: 20px 0px;
      }
    }
    .btn-hidden {
      border: transparent;
      background-color: transparent;
      color: transparent;
      padding: 10px;
      position: relative;
    }
    .fabars {
      display: inline-block;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }
    ul.collapsed {
      width: 100%;

      display: none;
      margin: 0 auto;
      text-align: center;

      max-height: 0;
      -moz-transition-duration: 0.4s;
      -webkit-transition-duration: 0.4s;
      -o-transition-duration: 0.4s;
      transition-duration: 0.4s;
      -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
      -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
      -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
      transition-timing-function: cubic-bezier(0, 1, 0.5, 1);

      &.is-expanded {
        display: block;
        max-height: 500px; /* approximate max height */
        -moz-transition-duration: 0.4s;
        -webkit-transition-duration: 0.4s;
        -o-transition-duration: 0.4s;
        transition-duration: 0.4s;
        -moz-transition-timing-function: ease-in;
        -webkit-transition-timing-function: ease-in;
        -o-transition-timing-function: ease-in;
        transition-timing-function: ease-in;
      }
      li {
        padding: 15px 10px;
        margin: 0px 0px;
        width: 100%;
      }
    }
  }
`;
